import { Box, Container } from '@mui/material';
import dayjs from 'dayjs';
import { authSlice } from 'features/auth/slice';
import { FC, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { isMobile } from 'react-device-detect';
import { useSearchParams } from 'react-router-dom';
import {
  SEARCH_PARAM,
  WEB_IN_APP_EVENT,
  WEB_IN_APP_ID,
} from 'shared/constants/common';
import { useWebInApp } from 'shared/contexts/WebInAppContext/WebInAppContext';
import { useTypedDispatch } from 'shared/redux/store';
import { postMessage } from 'shared/utils/postMessage';

export type PageContainerProps = {};

const PageContainer: FC<PageContainerProps> = ({ children }) => {
  const dispatch = useTypedDispatch();
  const { webInAppId } = useWebInApp();
  const [searchParams] = useSearchParams();
  const token = searchParams.get(SEARCH_PARAM.TOKEN) || '';
  const [, setCookie, removeCookie] = useCookies([SEARCH_PARAM.TOKEN]);

  useEffect(() => {
    if (webInAppId === WEB_IN_APP_ID.AHAMOVE_MOBILE && isMobile) {
      postMessage(WEB_IN_APP_EVENT.HIDE_TOOLBAR);
    }
    if (token) {
      removeCookie(SEARCH_PARAM.TOKEN, {
        domain: process.env.REACT_APP_DOMAIN,
      });

      setCookie(SEARCH_PARAM.TOKEN, token, {
        expires: dayjs().add(3, 'month').toDate(),
        domain: process.env.REACT_APP_DOMAIN,
        sameSite: 'none',
        secure: true,
      });
      dispatch(authSlice.actions.updateAccessToken(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, token, webInAppId]);

  return (
    <Box
      height={'100%'}
      className='md:bg-desktop bg-gray-100 bg-cover bg-fixed bg-center'
    >
      <Container maxWidth='sm' disableGutters className='md:h-screen md:py-12'>
        <Box
          id='scrollableTarget'
          className='relative mt-[3.3125rem] flex min-h-[calc(100vh-3.3125rem)] flex-col bg-gray-100 md:mt-0 md:h-full md:min-h-full md:overflow-y-auto md:overflow-x-hidden md:rounded-lg md:shadow-md'
        >
          <>{children}</>
        </Box>
      </Container>
    </Box>
  );
};

export default PageContainer;
